<template>
  <div class="page-product current-page">
    <div class="product-content-wrapper">
      <ProductContent
        v-if="dataProduct && dataProduct.product"
        :data="dataProduct.product"
        type="product"
      />
    </div>

    <SliceZone
      wrapper="main"
      :slices="page?.data.slices ?? []"
      :components="components"
    />
  </div>
</template>

<script setup lang="ts">
import ProductContent from "@/components/ProductContent.vue";
import { useProductStore } from "@/stores/shopify/products";
import { components } from "~/slices";

const productStore = useProductStore();

const prismic = usePrismic();
const { data: page } = await useAsyncData("[product]", () =>
  prismic.client.getSingle("product")
);

const route = useRoute();

const dataProduct = ref(null);

onMounted(async () => {
  const product = await productStore.fetchProductByHandle(route.params.slug);
  console.log("Fetched Product Data:", product);
  dataProduct.value = product;
});

// useHead({
//   title: page.value?.data.meta_title,
//   meta: [
//     {
//       name: "description",
//       content: page.value?.data.meta_description,
//     },
//   ],
// });
</script>

<style lang="scss" scoped>
.product-content-wrapper {
  position: relative;
  min-height: 100vh;
  height: auto;
}
</style>
